<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          autocomplete="off"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="lg:mb-4">
            </div>
            <div class="lg:mb-2" v-if="(role === 7 || role === 8 || role === 3)">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable disabled />
                </el-form-item>
                <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
                <el-form-item prop="name">
                  <el-input
                    disabled
                    class="w-full"
                    v-model="form.name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
            <div class="flex items-center mb-1">
              <label class="text-sm font-semibold text-secondary-600 block">{{$t('configurations.group_type')}}</label>
              <base-tooltip-icon-html size="sm" :content="tooltipTipoGrupo" class="ml-2"/>
            </div>
              <el-form-item prop="tipo">
                <base-el-select class="w-full" :options="tiposGrupoFiltered" v-model="form.tipo" disabled />
              </el-form-item>
            </div>
            <!-- <div class="lg:mb-2" v-if="form.tipo == 2 || form.tipo === 3">
              <div class="mandatory">
                <div class="flex flex-row items-center  mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block">{{$tc('users.email', 2)}}</label>
                  <base-tooltip-icon size="sm" :content="contentTooltipEmail" class="ml-2"/>
                </div>
                <el-form-item prop="email">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div> -->

            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" disabled v-model="form.verTodoGroups" :active-text="$t('configurations.ver_todo_groups')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" disabled v-model="form.verTodoStatuses" :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" disabled v-model="form.verTodoCompanies" :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>
            
            <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('avisos.header')}}</h3>
            <div class="mb-4">
              <div>
                <el-switch class="switch-text break-normal" disabled v-model="form.EnviarAvisos" :active-text="$t('app.send_alerts')"></el-switch>
              </div>
            </div>
            <div class="mb-4">
              <div>
                <el-switch class="switch-text break-normal" disabled v-model="form.EnviarAvisosUsuarios" :active-text="$t('configurations.send_alerts_users')"></el-switch>
              </div>
            </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_emitida')}}</label>
                  <el-form-item prop="EmailAvisoNuevaEmitida" ref="EmailAvisoNuevaEmitida">
                    <el-input
                      clearable
                      disabled
                      class="w-full"
                      v-model="form.EmailAvisoNuevaEmitida"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_nueva_recibida')}}</label>
                  <el-form-item prop="EmailAvisoNuevaRecibida" ref="EmailAvisoNuevaRecibida">
                    <el-input
                      clearable
                      disabled
                      class="w-full"
                      v-model="form.EmailAvisoNuevaRecibida"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_cambio_estado')}}</label>
                  <el-form-item prop="EmailAvisoCambioEstado" ref="EmailAvisoCambioEstado">
                    <el-input
                      clearable
                      disabled
                      class="w-full"
                      v-model="form.EmailAvisoCambioEstado"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_vincul')}}</label>
                  <el-form-item prop="EmailAvisoVinculaciones" ref="EmailAvisoVinculaciones">
                    <el-input
                      clearable
                      disabled
                      class="w-full"
                      v-model="form.EmailAvisoVinculaciones"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteGroup()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreGroup()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
        :title="$t('groups.delete_group')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getClients } from '@/services/clients/getClients'
import { getGroup } from '@/services/configurations/groups/getGroup'
import { deleteTrashGroup } from '@/services/trash/deleteTrashGroup'
import { restoreTrashGroup } from '@/services/trash/restoreTrashGroup'
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-grupo',
  components: {
    DetailLayoutFullWidth,
    Dialog
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: i18n.t('trash.group_detail'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/groups'
      },
      maxLengthCorreos: 500,
      form: this.getDefaultForm(),
      clientes: [],
      tooltipverTodoGroups: i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.groups.ver_todo_companies'),
      tooltipTipoGrupo: i18n.t('tooltip.html.groups.tipo_grupo'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation', { entity: i18n.t('groups.entity_name').toLowerCase() }),
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposGrupoFiltered () {
      const tiposGrupo = this.$store.getters['config/TIPOS_GRUPO']
      if (this.isCreate) return tiposGrupo.filter(x => x.create)
      else return tiposGrupo
    },
    formatCodigoPaisSMSAvisoDescargada () {
      if (this.form?.CodigoPaisSMSAvisoDescargada === '0034') return '+34'
      return 'Desconocido'
    },
  },
  watch: {
  },
  created: async function () {
    const breadcrumbs = []
    
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
    }

    await this.downloadData(this.id)
    if (this.form.tipo === 3) {
      this.$refs.baseCollapsibleAlerts.openAndDisable()
    }
    breadcrumbs.push({ path: 'trash/groups', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/groups', name: i18n.t('trash.groups') })
    breadcrumbs.push({ path: '', name: this.form.name })
    this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteGroup () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        payload.idGrupos.push(this.id)
        const response = await deleteTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreGroup: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        payload.idGrupos.push(this.id)
        const response = await restoreTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        tipo: '',

        company: '',
        active: false,
        clienteId: '',
        verTodoGroups: false,
        verTodoStatuses: false,
        verTodoCompanies: false,
        EnviarAvisos: false,
        EnviarAvisosUsuarios: false,
        EmailAvisoNuevaEmitida: '',
        EmailAvisoNuevaRecibida: '',
        EmailAvisoCambioEstado: '',
        EmailAvisoVinculaciones: '',
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    goBack: function () {
      this.$router.push({ name: 'trash/groups' })
    },
    downloadData: async function (id) {
      let group = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idGrupo: id,
          borrado: true,
        }
        group = await getGroup(params)
        this.setGroup(group.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return group
    },
    setGroup: function (group) {
      this.form.id = group.IdGrupo
      this.form.name = group.Nombre
      this.form.email = group.Emails
      this.form.tipo = group.idTipo
      this.form.clienteId = group.idCliente
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EmailAvisoNuevaEmitida = group.EmailAvisoNuevaEmitida
      this.form.EmailAvisoNuevaRecibida = group.EmailAvisoNuevaRecibida
      this.form.EmailAvisoCambioEstado = group.EmailAvisoCambioEstado
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
